import React, { Component } from 'react';
import './notice-list-view.less';
export default class NoticeListView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShown: false,
			config: {},  //drop内容位置，大小，是否可滚动等等
		}
	}
	makeList(count) {
		let list = [];
		for (let i = 0; i < count; i++){
			let height = this.props.delegate && this.props.delegate.heightForRowAtIndex(this, i);
			let content = this.props.delegate && this.props.delegate.cellForRowAtIndexPath(this, i);
			let key = this.props.delegate && this.props.delegate.reactKeyRowAtIndexPath(this, i);
			let item = <div id={'item' + i}
				key={key}
				style={{
					height: height + 'px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}>
				{content}
			</div>
			list.push(item);
		}
		return list;
	}
	render() {
		let count = this.props.delegate && this.props.delegate.numberOfRows(this) || 0;
		if (count < 1) {
			return null;
		}
		return <div id='list-view'>
			{
				this.makeList(count)
			}

		</div>;
	}
}